import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

class Assets extends Component {
    render() {
        return <div className="Theme">{this.props.children}</div>;
    }
}

Assets.propTypes = {
    children: PropTypes.element
};

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level
    };
};

const mapDispatchToProps = dispatch => ({
    modalSave: {
        show: () => dispatch(modalSaveActions.show())
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Assets);



// WEBPACK FOOTER //
// ./src/components/assets/Assets.js